<template>
   <v-hover v-model="hoverElement">
    <template v-slot:default="{ hover }">
  <div :class="`bundle-header ${hover && hasBundle && !isSingle? 'bundle-header__hover': ''} ${hasActiveBundleType? 'bundle-header__active': ''}`">
    <div class="bundle-header__title">
      <span :class="`${hasActiveBundleType? 'bundle-header__title--active': ''}`">{{ title }}</span>
      <span class="bundle-header__title--info">
        <v-tooltip bottom :disabled="!incompleteCriteria">
          <template v-slot:activator="{ on, attrs }">

            <v-chip
              v-bind="attrs"
              v-on="on"
              class="bundle-criteria-chip"
              color="transparent"
              small
              label
              style="margin: 0; padding: 0;"
              text-color="black"
              >
            
        <div class="icon icon__complete"  v-if="isBundleComplete"></div>
        <div class="icon icon__incomplete" v-else></div>
            </v-chip>
          </template>
          <span>{{ incompleteCriteria }}</span>
      </v-tooltip>
        <!-- <v-icon class="icon-general icon-general--active icon-general--no-border" v-if="bundle.status === 'complete'">mdi-checkbox-blank</v-icon> -->
        <!-- <v-icon class="icon-general icon-general--inactive" v-else>mdi-checkbox-blank</v-icon> -->
        <div class="bundle-header__additional" v-if="hasBundle">
          <!-- <v-btn class="ml-2" elevation="0" light rounded color="#888" fab text x-small @click="showChart">
            <v-icon small>mdi-chart-bar</v-icon>
          </v-btn>
            <v-btn class="ml-2" elevation="0" light rounded color="#888" fab text x-small @click="showHistoryChart">
              <v-icon small>mdi-chart-bar</v-icon>
            </v-btn> -->
            <v-btn class="ml-2" elevation="0" light rounded color="#888" fab text x-small @click="showCharts">
              <v-icon small>mdi-chart-bar</v-icon>
            </v-btn>

          <v-btn class="deleteBundle1" v-if="bundle && bundle.isDeleteable" elevation="0" light rounded color="#888" fab text x-small @click="onBundleDelete">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </span>
    </div>
    <div class="bundle-header__info">
      <!-- Bundle Name: Tray, Paper Wrap... -->
      <span v-if="bundle && bundle.bundletype != null">
        {{ bundleTypeName }}
        <template v-if="bundle.bundletype.name == 'display'">
          <br /><small>{{ bundle.attributes.displayside }}</small>
        </template>

        <template v-if="bundle.bundletype.name == 'cardboard_box'">
          <br /><small>{{ bundle.attributes.bars }}</small>
        </template>
      </span>
      <span v-if="allGtins">{{ allGtins }}</span>
      <!-- <span v-if="alternativeGtin">{{ $t("ARTICLE-BUNDLE-ALTERNATIVE_GTIN") }} {{ alternativeGtin }}</span> -->
      <span v-if="articleNo">{{ $t("ARTICLE-BUNDLE-ARTICLE_NO") }} {{ articleNo }}</span>
      <!-- <span v-if="kisoftId">{{ $t("ARTICLE-BUNDLE-KISOFT_ID") }} {{ kisoftId }}</span> -->
      <v-fade-transition>
          <v-overlay
            v-if="hover && hasBundle && !isSingle && !hasActiveBundleType"
            absolute
            z-index="10"
            color="white"
          >
            <v-btn color="secondary" @click="setAsActiveBundle">{{ $t('SET-AS-ACTIVE') }}</v-btn>
          </v-overlay>
        </v-fade-transition>
    </div>
    <div class="bundle-header__image">
      <img v-if="hasImage" :src="image" alt="" @click="showBigImage(image)" class="bundle-header__image-main" />
      <v-row v-else class="fill-height ma-0" align="center" justify="center" >
          </v-row>
   
      <div class="bundle-header__image-additionals" v-if="hasBundle">
        <template v-if="!isPalletBundle"
          >
          <ThumbItemImage :image="imageFront" :bundleId="bundle.id" type="image_front" @showBigImage="showBigImage($event)"/>
          <ThumbItemImage :image="imageIso" :bundleId="bundle.id" type="image_iso" @showBigImage="showBigImage($event)"/>
      </template>
      <template v-else-if="isPalletBundle"
          >
          <ThumbItemImage :image="paleteImage" :bundleId="bundle.id" type="image_pallet" @showBigImage="showBigImage($event)"/>
          <ThumbItemImage :image="paleteImage2" :bundleId="bundle.id" type="image_pallet2" @showBigImage="showBigImage($event)"/>
      </template>
      </div>
    </div>
    <ul class="bundle-header__details">
      <li class="bundle-header__details-item" v-for="(item, index) in displayDetails" :key="index" @click="editDetailItem(item)" :class="`${item.attribute_id? 'bundle-header__details-item-edit':''}`">
        <template v-if="item && item.value"> 
        <span class="bundle-header__details-item--icon" v-if="validIcon(item.icon)"> <v-icon>mdi-{{ item.icon }}</v-icon> </span> 
        <span class="bundle-header__details-item--icon" data-icon-label v-else-if="!item.attribute_id"> {{ $t(`ICON-ITEM-${item.icon.toUpperCase()}`) }} </span> 
        <span class="bundle-header__details-item--icon" data-attribute-icon v-else> {{ getAttributeName(item.attribute_id, item.icon) }} </span> 
        <div class="bundle-header__details-item--content">
          <span v-text="item.value" v-if="item.value" />
        </div>
        </template>
        <template v-else-if="item && item.tags && item.tags.length > 0">
          <div class="bundle-header__details-item--content">
          <simple-chip
              :name="tag.name"
              v-for="(tag, tagIndex) in item.tags"
              @click="editDetailItemWithTag(tag)"
              :class="`${tag.attribute_id? 'bundle-header__details-item-edit':''}`"
              :key="tagIndex"
              :defaultIcon="false"
              :readonly="true"
              :color="tag.active? 'primary':'secondary'"
              small
              forceColor
              :equalSize="false"
            />
          </div>
        </template>
        <template v-else>
          <div class="bundle-header__details-item--content"></div>  
        </template>
        
      </li>
    </ul>
    <v-overlay z-index="999999999" color="#FFF" :value="showImageOverlay" @click="showImageOverlay = false">
      <div style="display: flex; max-width: 100vw; max-height: 100vh; overflow: hidden; padding: 4em 1em; 1em">
      <v-img :src="selectedItem ? selectedItem : ''" contain max-height="80%">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular size="64" width="4" indeterminate color="grey"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      </div>
    </v-overlay>
    <Dialog :propBundle="bundle" :itemEdited="editedItem" :dialogSettings="dialog" @closeModal="closeModal" @changeAttribute="changeAttribute" />

  </div>
  
</template>
</v-hover>
</template>

<script>
import { cloneDeep } from "lodash";
import SimpleChip from "../ui-elements/SimpleChip.vue";
import Dialog from "./Dialog.vue";
import { EditAttributeDialogMixin } from "@/components/item/EditAttributeDialogMixin";
import ThumbItemImage from "./ThumbItemImage.vue";

export default {
  name: "GeneralData",
  mixins: [EditAttributeDialogMixin],
  components: { SimpleChip, Dialog, ThumbItemImage },
  props: {
    bundle: {
      type: Object,
      default: null
    },
    bundleType: {
      type: String,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isSingle:{
      type: Boolean,
      default: false
    },
    detailsAmount: {
      type: Number,
      default: 9,
    },
    activeBundleType:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hoverElement: false,
      editedItem: null,
      weightAttribute: null,
      dimensionAttributes: [],
      tolaranceHeightPlus: null,
      tolaranceHeightMinus: null,
      tolaranceLengthMinus: null,
      tolaranceLengthPlus: null,
      tolaranceWidthPlus: null,
      tolaranceWidthMinus: null,
      // attributeDetails: [],
      selectedItem: null,
      showImageOverlay: false,
      fragileAttribute: null,
      dangerousAttribute: null,
      sideUpAttribute: null,
      gluedLayers: null,
      foiledType: null,
      foiled: null,
      trayHeight: null,
      displaySide: null,
      bottleArrangement: null,
      bottleClosureRatio: null,
    };
  },
  computed: {
    incompleteCriteria(){
      if(!this.hasBundle) return false;
      return this.bundle.incomplete_criteria;
    },
    hasActiveBundleType(){
      return this.activeBundleType === this.bundleType;
    },
    validIcon(){
      return (iconName) => {
        return false;
        // return iconName.length >0 && [].includes(iconName);
      }
    },
    imageFront(){
      if(this.bundle && this.bundle.attributes != null && this.bundle.attributes.image_front){
        if(this.bundle.attributes.image_front && this.bundle.attributes.image_front.toLowerCase().startsWith('http')) return this.bundle.attributes.image_front;
        const image = this.bundle.attributes.image_front_cdn ? this.bundle.attributes.image_front_cdn : this.$config.uploads + this.bundle.attributes.image_front;
      return cloneDeep(image);
      }
      return null;
    },
    imageIso(){
      if(this.bundle  && this.bundle.attributes != null && this.bundle.attributes.image_iso ){
        if(this.bundle.attributes.image_iso && this.bundle.attributes.image_iso.toLowerCase().startsWith('http')) return this.bundle.attributes.image_iso;
        
        const image = this.bundle.attributes.image_iso_cdn ? this.bundle.attributes.image_iso_cdn : this.$config.uploads + this.bundle.attributes.image_iso;
      return cloneDeep(image);
      }
      return null;
    },

    paleteImage(){
      if(this.bundle  && this.bundle.attributes != null && this.bundle.attributes.image_pallet  ){
        if(this.bundle.attributes.image_pallet && this.bundle.attributes.image_pallet.toLowerCase().startsWith('http')) return this.bundle.attributes.image_pallet;
        
        const image = this.bundle.attributes.image_pallet_cdn
                ? this.bundle.attributes.image_pallet_cdn
                : this.$config.uploads + this.bundle.attributes.image_pallet;
      return cloneDeep(image);
      }
      return null;
    },

    paleteImage2(){
      if(this.bundle && this.bundle.attributes != null && this.bundle.attributes.image_pallet2  ){
        if(this.bundle.attributes.image_pallet2 && this.bundle.attributes.image_pallet2.toLowerCase().startsWith('http')) return this.bundle.attributes.image_pallet2;
        
        const image = this.bundle.attributes.image_pallet2_cdn
                ? this.bundle.attributes.image_pallet2_cdn
                : this.$config.uploads + this.bundle.attributes.image_pallet2;
      return cloneDeep(image);
      }
      return null;
    },
    getAttributeName(){
      return (attributeId, iconName) => {
        const item = this.bundle.attributesDetails.find(item => item.attribute.id == attributeId );
        if(!item) return this.$t('ICON-ITEM-'+iconName.toUpperCase());
        if(item.attribute.displayName && item.attribute.displayName[this.$store.getters.langShortcode]) return item.attribute.displayName[this.$store.getters.langShortcode];
        return item.attribute.name;
      }
    },
    hasBundle(){
      return this.bundle != null;
    },
    isBundleComplete(){
      if(!this.hasBundle) return false;
      return this.bundle.status === 'complete';
    },
    isPalletBundle() {
      return this.bundleType === "pallet";
    },
    isUnitBundle(){
      return this.bundleType === 'unit';
    },
    isPackBundle(){
      return this.bundleType === 'pack';
    },
    allGtins(){
      if(!this.hasBundle) return '';
      const list = [];
      if(this.gtin) list.push(this.gtin);
      if(this.alternativeGtin) list.push(this.alternativeGtin);
      return list.join(', ');
    },
    details(){
      let list = [];
      if(!this.bundle || !this.bundle.displayData)return list;
      if(this.isPalletBundle){
        list = cloneDeep(this.bundle.displayData.pallet && this.bundle.displayData.pallet.main_attributes || []);
      }else{
        list = cloneDeep(this.bundle.displayData.main_attributes || []);
      }
      return list.filter(el => el && (el.value || el.tags));
    },
    displayDetails(){
      return this.populateEmptyDetailItems(this.details);
    },
    gtin() {
      if (this.isPalletBundle) return "";
      return this.bundle.gtin;
    },
    alternativeGtin() {
      if (this.isPalletBundle) return "";
      return this.bundle.alternativeGtin;
    },
    articleNo() {
      if (this.isPalletBundle) return "";
      if(!this.bundle || !this.bundle.articleNo) return "";
      return this.bundle.articleNo;
    },
    kisoftId() {
      if (this.isPalletBundle) return "";
      return this.bundle.kisoftId;
    },
    hasImage() {
      if(!this.hasBundle) return false;
      if (this.isPalletBundle) return this.bundle.loadcarrier.image;
      return this.bundle.bundletype != null && this.bundle.bundletype.image != null;
    },
    image() {
      if(!this.hasImage) return '';
        
      if (this.isPalletBundle){
        if(this.bundle.loadcarrier.image && this.bundle.loadcarrier.image.toLowerCase().startsWith('http')) return this.bundle.loadcarrier.image;
        return this.$config.cdn + this.bundle.loadcarrier.image;
      } 

      if(this.bundle.bundletype.image && this.bundle.bundletype.image.toLowerCase().startsWith('http')) return this.bundle.bundletype.image;
      return this.$config.cdn + this.bundle.bundletype.image;
    },
    title() {
      if(!this.hasBundle){
        if(this.isPalletBundle) return this.$t("ARTICLE-BUNDLE-PALLET");
        if(this.isPackBundle) return this.$t('ARTICLE-BUNDLE-PACK');
        if(this.isUnitBundle) return this.$t('ARTICLE-BUNDLE-UNIT');
        return this.$t('ARTICLE-BUNDLE-CASE');
      }
      if (this.isPalletBundle) {
        return this.$t("ARTICLE-BUNDLE-PALLET");
      }
      return this.$t("ARTICLE-BUNDLE-" + this.bundleType.toUpperCase() + "-TITLE");
    },
    bundleTypeName() {
      if(!this.hasBundle) return '';
      if (this.isPalletBundle) {
        return this.bundle.loadcarrier.name != null ? this.bundle.loadcarrier.name : "";
      }
      return this.$t("bundletype_" + this.bundleType + "_" + this.bundle.bundletype.name);
    },
  },
  created() {
    this.$emit('updateDetailsAmount', this.details.length);
  },
  methods: {
    showBigImage(img){
      this.selectedItem = cloneDeep(img);
      this.showImageOverlay = true;
    },
    editDetailItem(item){
      if(item.tags && item.tags.length){
        // tags are handled by editDetailItemWithTag method
        return false;
      }
      if(!item.attribute_id)return false;
      this.editAttribute(this.getAttributeById(item.attribute_id));

    },
    getAttributeById(id){
      const element = this.bundle.attributesDetails.find(el => el.attribute && el.attribute.id === id);
      if(!element) throw Error(`Attribute with id: ${id} cannot be found!`);
      return element.attribute;
    },
    editDetailItemWithTag(tag){
      if(!tag.attribute_id) return false;
      this.editAttribute(this.getAttributeById(tag.attribute_id));
    },
    setAsActiveBundle(){
      this.$emit('setActiveBundleType', {type: this.bundleType, attributeDetails: cloneDeep(this.attributeDetails)});
    },
    showChart() {
      this.dialog.type = "chart";
      this.dialog.width = "96%";
      this.dialog.show = true;
      this.dialog.isLoading = true;
    },

    showHistoryChart() {
      this.dialog.type = "history-chart";
      this.dialog.width = "96%";
      this.dialog.show = true;
      this.dialog.isLoading = true;
    },
    
    showCharts() {
      this.dialog.type = "charts";
      this.dialog.width = "96%";
      this.dialog.show = true;
      this.dialog.isLoading = true;
    },
    
    onBundleDelete() {
      this.$emit("deleteBundle", this.bundle);
    },
    populateEmptyDetailItems(list) {
      if (list.length < this.detailsAmount) {
        const size = this.detailsAmount - list.length;
        for (let i = 1; i <= size; i++) {
          list.push("");
        }
      }
      return list;
    },
  
  },
};
</script>

<style lang="scss" scoped>
.bundle-header {
  display: flex;
  flex: 1;
  padding: .5em .5em 1.5em;
  position: relative;
  flex-direction: column;
  &__hover{
    // background-color: rgb(27, 153, 167, .2);
    background-color: lighten(#f0f0f0, 3);
    
  }

  &__active{
    background-color: lighten(#f0f0f0, 15);
  }

  &__title {
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 16.1px;
    font-weight: 700;
    position: relative;
    color: #494949;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--active{
      color: rgb(27, 153, 167);
    }

    &--info {
      text-align: right;
      position: relative;
      
      & > .icon-general {
        margin-right: 0.25em;
      }
    }
  }

  &__additional {
    display: flex;
    position: absolute;
    right: -4px;
    top: 25px;
    z-index: 1000;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }

  &__info {
    min-height: 100px;
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    font-size: 14px;
    color: #666666;
    position: relative;
  }

  &__image {
    height: 140px;
    display: flex;
    justify-content: center;
    margin: 2.5em 0 4.5em;
    align-items: center;
    position: relative;
    z-index: 100000;
    &-additionals {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: absolute;
      width: 100%;
      bottom: -55px;
      // background-color: rgba(255,255,255,.2);
      left: 0;
      z-index: 1000000000;
    }

    &-main {
      display: flex;
      justify-content: center;
      align-items: center;
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
      background-size: contain;
      &:hover {
        -webkit-filter: none; /* Safari 6.0 - 9.0 */
        filter: none;
      }
      // border: 1px solid #ccc;
      max-width: 200px;
      max-height: 146px;
    }
  }

  &__details {
    flex: 1;
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    &-item {
      &-edit{
        cursor: pointer;
      }

      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      // padding-bottom: 0.25em;
      border-bottom: 1px solid rgba(64, 64, 70, 0.3);
      // opacity: 0.5;
      height: 36px;
      &--icon {
        flex: 0 1 70px;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 10px;
        text-transform: capitalize;
        position: relative;
        & img {
          display: block;
          width: auto;
          height: 80%;
          -webkit-filter: grayscale(100%) brightness(70%); /* Safari 6.0 - 9.0 */
          filter: grayscale(100%) brightness(70%);
          // filter: grayscale(100%)  brightness(50%);
        }
      }

      &--content {
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        position: relative;
        font-family: Arial, sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #666666;

        &-noicon {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          margin-left: 1.5em;
          justify-content: flex-start;
          & > * {
            margin-right: 0.5em;
          }
        }

        &--image {
          height: 70%;
          width: auto;
          display: block;
          -webkit-filter: grayscale(100%) brightness(70%); /* Safari 6.0 - 9.0 */
          filter: grayscale(100%) brightness(70%);
          margin: 0 1em 0 1em;

          &:first-of-type {
            margin-left: 2em;
          }
        }
      }
    }
  }
}
.bundle-criteria-chip{
  &,&:link, &:visited, &:hover{
    background: transparent!important;
    &::before{
      opacity: 0;
    }
  }
}
</style>
